import { render, staticRenderFns } from "./ReportDetailPage.vue?vue&type=template&id=ca997404&"
import script from "./ReportDetailPage.vue?vue&type=script&lang=js&"
export * from "./ReportDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailPage.vue?vue&type=style&index=0&id=ca997404&prod&lang=scss&"
import style1 from "./ReportDetailPage.vue?vue&type=style&index=1&id=ca997404&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports